export const grey = {
  0: '#000000',
  10: '#0D111A',
  15: '#131926',
  20: '#1A2233',
  25: '#202B40',
  30: '#26334D',
  35: '#2D3C59',
  40: '#334466',
  45: '#3F5073',
  50: '#4D5E80',
  55: '#62708C',
  60: '#6B7A99',
  65: '#7C8AA6',
  70: '#7D8FB3',
  75: '#99A6BF',
  80: '#ADB8CC',
  85: '#C3CAD9',
  90: '#DADEE6',
  91: '#DCE0E8',
  92: '#DFE3EB',
  93: '#E1E5ED',
  94: '#E4E7F0',
  95: '#EDEFF2',
  96: '#F2F3F5',
  97: '#F5F6F7',
  98: '#F7F8FA',
  99: '#FAFBFC',
  100: '#ffffff'
}

export const blue = {
  100: '#0890BB',
  200: '#0AA6D8',
  500: '#09B5EC',
  700: '#09B5EC',
  900: '#31C9FA'
}

export const green = {
  100: '#66FF75',
  200: '#45E655',
  500: '#29CC39',
  700: '#13BF24',
  900: '#00B311'
}

export const purple = {
  100: '#66FF75',
  200: '#7919FF',
  500: '#8833FF',
  700: '#7919FF',
  900: '#6A00FF'
}

export const orange = {
  100: '#FF8D66',
  200: '#FF794D',
  500: '#FF6633',
  700: '#E64B17',
  900: '#CC4314'
}

export const red = {
  100: '#FF6666',
  200: '#F24949',
  500: '#E62E2E',
  700: '#CC1414',
  900: '#B20000'
}

export const yellow = {
  100: '#FFD559',
  200: '#E6B117',
  500: '#FFCB33',
  700: '#FFD559'
}

export const bronze = {
  100: '#E69B5C',
  200: '#D98741',
  500: '#CC7429',
  700: '#B35C12',
  900: '#994700'
}

export const tiffany = {
  100: '#66FFE8',
  200: '#49F2D8',
  500: '#2EE6CA',
  700: '#14CCB0',
  900: '#00B397'
}

export const gradient = {
  1: 'linear-gradient(196.77deg, #FF46AA 0.6%, #FDF37A 136.46%)',
  2: 'linear-gradient(196.77deg, #FDB061 0.6%, #F4DA50 136.46%)',
  3: 'linear-gradient(196.77deg, #6246FF 0.6%, #FFB9B9 136.46%)',
  5: 'linear-gradient(180deg, #1ABFFB 0%, #1D77F2 100%)'
}

export const categoryColor = {
  1: 'linear-gradient(196.77deg, #6246FF 0.6%, #FFB9B9 136.46%)',
  2: 'linear-gradient(196.77deg, #FDB061 0.6%, #F4DA50 136.46%)',
  3: 'linear-gradient(196.77deg, #FF46AA 0.6%, #FDF37A 136.46%)',
  4: 'linear-gradient(180deg, #1ABFFB 0%, #1D77F2 100%)',
  5: 'linear-gradient(196.77deg, #3DBA1D 0.6%, #8FD31F 136.46%)',
  6: 'linear-gradient(180deg, #1AFBC5 0%, #79EFFF 100%)'
}
